import { render, staticRenderFns } from "./OurLocation.vue?vue&type=template&id=14c0bc82&scoped=true&"
import script from "./OurLocation.vue?vue&type=script&lang=js&"
export * from "./OurLocation.vue?vue&type=script&lang=js&"
import style0 from "./OurLocation.vue?vue&type=style&index=0&id=14c0bc82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c0bc82",
  null
  
)

export default component.exports